import { Select } from 'antd'
import React, { useState } from 'react'

export default function MultiSelectExpretOpenPage({options, value, onChangeFunc,width }) {
    const [domainNameSelected, setDomainNameSelected] = React.useState([])
    const handleChange = (value) => {
        // console.log(value,'check value')
        let newVal = value.map((obj, ind) => {
            return { value: obj, label: obj, name:obj }
        })
        onChangeFunc(newVal)
        setDomainNameSelected(newVal)
    };
    return (
        <>
            <Select
                size='large'
                mode="multiple"
                allowClear
                options={options}
                style={{ width: '260px',color:'#24A36A'}}
                placeholder="Select Domains"
                onChange={handleChange}
                value={value}
                optionLabelProp="label"
                defaultValue={[{label:'Select Domains',value:'Select Domains'}]}
                filterOption={(input, option) =>
                    option?.label.toLowerCase().includes(input.toLowerCase())
                }
                maxTagCount={0}  // Hide the tags
            maxTagPlaceholder={`${value.length} selected`}  // Custom placeholder
            />
        </>
    )
}
